//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import links from "../links";

export default {
  name: "about",
  mixins: [links],
  data() {
    return {
      mail: "",
      text: "",
      subject: "",
      disable: false,
      labelButton: "Send",
    };
  },
  methods: {
    goToLinkedin() {
      window.open(this.linkedinLink);
    },
    isMailValid() {
      const reglasMail = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
      if (reglasMail.test(this.mail)) this.disable = false;
      else {
        this.disable = true;
        return "Invalid email";
      }
    },
    sendMail() {
      // Creating a XHR object
      let xhr = new XMLHttpRequest();
      let url =
        "https://frpuocxxql.execute-api.eu-west-3.amazonaws.com/dev/users/create";

      // open a connection
      xhr.open("POST", url, true);

      // Set the request header i.e. which type of content you are sending
      xhr.setRequestHeader("Content-Type", "application/json");

      // Converting JSON data to string
      var data = JSON.stringify({
        message: this.text,
        Subject: this.subject,
        emailTo: this.mail,
      });

      // Sending data with the request
      xhr.send(data);

      this.mail = "";
      this.subject = "";
      this.text = "";
      this.disable = true;
      this.labelButton = "Submitted";
      // alert("Sorry, your email could not be sent");
    },
  },
};
